import React, { Component } from "react";
import { Col, Card, Form, Button, Collapse } from "antd";
import _ from "lodash";
import momentTZ from "moment-timezone";
import { formatRupiah } from "../../../../Utils";

class RequestSection extends Component {
  buttonStatus(request, label, approvedDiscount, requestNow) {
    let button;
    if (request) {
      if (request.status === "Dalam Proses") {
        button = (
          <div>
            <span
              className="ant-form-text form-text-mod"
              style={{ marginLeft: 5 }}>
              {formatRupiah(request.requestPrice)}{" "}
            </span>
            <Button disabled> Sedang Dalam Request </Button>
          </div>
        );
      } else if (request.status === "Rejected" || request.status === "Cancel") {
        button = requestNow ? (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <Button
                disabled
                type="primary"
                onClick={() =>
                  this.props.visibleModal(request.status_label, true)
                }>
                {" "}
                REQUEST AGAIN{" "}
              </Button>
            </div>
            <div>
              <span
                className="ant-form-text"
                style={{ color: "#FF1D1D", display: "block", marginBottom: 5 }}>
                &nbsp;&nbsp;{request.status} by{" "}
                {request.Director
                  ? request.Director.directors_role
                  : "Super Admin"}
              </span>
              <span className="ant-form-text" style={{ color: "#002558" }}>
                &nbsp;&nbsp;
                {momentTZ(request.updatedAt)
                  .tz("Asia/Jakarta")
                  .format("ddd, D MMM YYYY HH:mm")}{" "}
                | {request.Director ? request.Director.name : null}
              </span>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: 10, marginBottom: 15 }}>
            <span className="ant-form-text" style={{ color: "#FF1D1D" }}>
              {request.status} by&nbsp;
              {request.Director
                ? request.Director.directors_role
                : "Super Admin"}
              &nbsp;
            </span>
            <span className="ant-form-text" style={{ color: "#002558" }}>
              |&nbsp;
              {momentTZ(request.updatedAt)
                .tz("Asia/Jakarta")
                .format("ddd, D MMM YYYY HH:mm")}
              &nbsp; | {request.Director ? request.Director.name : null}
            </span>
          </div>
        );
      } else if (request.status === "Approved") {
        button = (
          <div>
            <span className="ant-form-text" style={{ color: "#A4D166" }}>
              Approved by {request.Director.directors_role}{" "}
            </span>
            <span className="ant-form-text" style={{ color: "#002558" }}>
              |{" "}
              {momentTZ(request.updatedAt)
                .tz("Asia/Jakarta")
                .format("ddd, D MMM YYYY HH:mm")}{" "}
              | {request.Director.name}
            </span>
          </div>
        );
      }
    } else {
      if (label === "Discount") {
        button = (
          <Button
            disabled
            type="primary"
            onClick={() => this.props.visibleModal("Discount", true)}>
            {" "}
            REQUEST NOW{" "}
          </Button>
        );
      } else {
        if (approvedDiscount) {
          button = (
            <Button
              disabled
              type="primary"
              onClick={() => this.props.visibleModal("MRP", true)}>
              {" "}
              REQUEST NOW{" "}
            </Button>
          );
        } else {
          button = <Button disabled> REQUEST NOW </Button>;
        }
      }
    }
    return button;
  }

  getStatusRequest(discount, mrp, type, requestNow) {
    let button;
    //Button Discount
    if (type === "Discount") {
      if (discount && discount.status) {
        button = this.buttonStatus(discount, type, false, requestNow);
      } else {
        button = this.buttonStatus(discount, type);
      }
    }
    // Button MRP
    else if (type === "MRP") {
      if (mrp && mrp.status) {
        button = this.buttonStatus(mrp, type, false, requestNow);
      } else {
        if (discount && discount.status === "Approved") {
          button = this.buttonStatus(mrp, type, true);
        } else {
          button = this.buttonStatus(mrp, type, false);
        }
      }
    }
    return button;
  }

  getNotes(request) {
    let notes;
    if (request) {
      if (request.status !== "Dalam Proses") {
        notes = (
          <Form.Item label="Notes Direksi">
            <span className="ant-form-text form-text-mod">
              {" "}
              {request.directorsNotes}{" "}
            </span>
          </Form.Item>
        );
      }
    }
    return notes;
  }

  render() {
    const { request, approvalType } = this.props;
    const discount = _.filter(request, { status_label: "Discount" });
    const mrp = _.filter(request, { status_label: "MRP" });

    //First Request
    const discountNow = _.find(discount, { status_label: "Discount" });
    const mrpNow = _.find(mrp, { status_label: "MRP" });
    return request ? (
      <Col xs={24} md={12}>
        <Card title="Request Section">
          {/* Discount section */}
          {discountNow ? (
            <div>
              <Form.Item label="Pengajuan Discount BOD">
                {this.getStatusRequest(discountNow, null, "Discount", true)}
              </Form.Item>
              {this.getNotes(discountNow)}
            </div>
          ) : (
            <Form.Item label="Pengajuan Discount BOD">
              {this.getStatusRequest(null, null, "Discount", false)}
            </Form.Item>
          )}

          {discount && discount.length > 1 && (
            <Collapse ghost>
              <Collapse.Panel header="Request Discount History" key="1">
                {discount.map(
                  (v, i) =>
                    i !== 0 && this.getStatusRequest(v, null, "Discount", false)
                )}
              </Collapse.Panel>
            </Collapse>
          )}
          {/* END Discount section */}

          {/* MRP section */}
          {approvalType === "Trade In" &&
            (mrpNow ? (
              <div>
                <Form.Item label="Request MRP">
                  {this.getStatusRequest(discountNow, mrpNow, "MRP", true)}
                </Form.Item>
                {this.getNotes(mrpNow)}
              </div>
            ) : (
              <Form.Item label="Request MRP">
                {this.getStatusRequest(discountNow, null, "MRP", false)}
              </Form.Item>
            ))}

          {approvalType === "Trade In" && mrp && mrp.length > 1 && (
            <Collapse ghost>
              <Collapse.Panel header="Request MRP History" key="2">
                {mrp.map(
                  (v, i) =>
                    i !== 0 &&
                    this.getStatusRequest(discountNow, v, "MRP", false)
                )}
              </Collapse.Panel>
            </Collapse>
          )}
          {/* END MRP section */}
        </Card>
      </Col>
    ) : null;
  }
}

export default RequestSection;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/RequestSection.js